// extracted by mini-css-extract-plugin
export default {"heading":"es-z","createAccount":"fs-z","disabled":"gs-z","copy":"hs-z","terms":"is-z"};